import React from 'react';
import { ScrollLink } from '@prisjakt/ui-scroll';
import { AppContext } from '@prisjakt/ui-app-context';
import ViewAllButton from './view-all-button';
import { Category } from '../../types';

import * as S from './styles';

type Props = {
  category: Category;
  menuHistory: Category[];
  isTraversingUpwards: boolean;
  previousCategory: Category | null;
  closeMenu: () => void;
  showSidebar?: boolean;
  changeMenuLevel: (category: Category) => void;
};

class Categories extends React.PureComponent<Props> {
  renderTopLevelCategoryItem = (category: Category) => {
    return this.renderCategoryItem(category, true);
  };

  renderNestedCategoryItem = (category: Category) => {
    return this.renderCategoryItem(category, false);
  };

  renderCategoryItem(category: Category, isTopLevelCategory: boolean) {
    const { linkTo } = this.context;

    const categoryLogo =
      this.props.showSidebar && isTopLevelCategory ? (
        <S.CategoryLogo src={category.logo && category.logo['96']} alt="" />
      ) : (
        undefined
      );

    if (category.children && category.children.length) {
      return (
        <ScrollLink key={category.id} to="Mobile Menu" direction="up">
          <S.StylesMenuItem
            name={category.name}
            onClick={() => this.props.changeMenuLevel(category)}
            sidebar={Boolean(this.props.showSidebar)}
            image={categoryLogo}
            showArrow={!this.props.showSidebar || !isTopLevelCategory}
          />
        </ScrollLink>
      );
    }

    return (
      <S.StylesMenuItem
        key={category.id}
        name={category.name}
        onClick={this.props.closeMenu}
        link={category.external_uri || linkTo('category', category)}
        isExternal={!!category.external_uri}
        sidebar={Boolean(this.props.showSidebar)}
        image={categoryLogo}
        showArrow={false}
      />
    );
  }

  render() {
    const {
      category,
      menuHistory,
      isTraversingUpwards,
      previousCategory,
      closeMenu,
      showSidebar,
    } = this.props;
    const currentCategory = menuHistory[menuHistory.length - 1];
    const isCurrentCategory = category.id === currentCategory.id;
    const { t, market } = this.context;

    if (!category.children) {
      return null;
    }

    const sortedChildren = [...category.children].sort((a, b) =>
      a.name.localeCompare(b.name, market.locale.replace('_', '-'))
    );

    const slideDirection =
      (isTraversingUpwards && isCurrentCategory) ||
      (!isTraversingUpwards && !isCurrentCategory)
        ? 'LEFT'
        : 'RIGHT';

    return (
      <S.Categories
        key={category.id}
        visible={isCurrentCategory}
        initialTransition={!!previousCategory}
        slide={showSidebar ? slideDirection : undefined}
        sidebar={Boolean(showSidebar)}
        data-test={isCurrentCategory && 'MenuCategories'}
      >
        {showSidebar && category.id === 'root' && (
          <S.CategoryListHeading>
            {t('header', 'categories.title')}
          </S.CategoryListHeading>
        )}
        {Boolean(category && category.semantic_id) && (
          <ViewAllButton
            category={category}
            closeMenu={closeMenu}
            showSidebar={Boolean(showSidebar)}
          />
        )}
        {sortedChildren.map(
          category.id === 'root'
            ? this.renderTopLevelCategoryItem
            : this.renderNestedCategoryItem
        )}
      </S.Categories>
    );
  }
}

Categories.contextType = AppContext;

export default Categories;
